export enum ServerErrorCode {
  DuplicatePhoneNumber = 'DuplicatePhoneNumber',
}
